// extracted by mini-css-extract-plugin
export var cell = "_6u-4";
export var headerCell = "_6u-2";
export var rowHeader = "_6u-3";
export var table = "_6u-1";
export var tableContainer = "_6u-0";